import { v4 as uuidv4 } from 'uuid';
import { assignPublisherColors } from '../../../../commons/utils/publisherColors';
import { normalizePublicPublishers } from './normalizePublicPublisher';
import { getTrendingNearMePublishersAPI } from './api';

// Backs the "Trending" page/popularNowPublishers field — despite the store
// field's name, its source is trending-near-me (ToRecommendedPublisherResponses:
// adds score/isNearYou/recommendationRank on top of the usual public shape).
async function getPopularNowPublishers() {
    this.observed.popularNowPublishersLoading = true;
    try {
        const session = this.env.session;
        const traceId = this.env.traceId;
        const timezone = this.env.countryInfo?.timezone;

        const res = await getTrendingNearMePublishersAPI({ token: session?.token, traceId, timezone });
        const data = res?.data?.data || res?.data || null;
        const publishers = data?.publishers || [];

        this.popularNowPublishers = assignPublisherColors(normalizePublicPublishers(publishers));
        this.observed.popularNowPublishers = uuidv4();
    } finally {
        this.observed.popularNowPublishersLoading = false;
    }
}

export default getPopularNowPublishers;
